import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

const ApiService = {
    init() {
        Vue.use(VueAxios, axios)

        Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL
    },

    setHeaderAuth() {
        // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${ window.token_dashboard_streamer }`
        Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${ window.access_token || window.token_dashboard_streamer }`
    },

    setHeaderLang() {
        Vue.axios.defaults.headers.common['Accept-Language'] = window.document_language
    },

    setHeaderIfModified(date) {
        Vue.axios.defaults.headers.common['If-Modified-Since'] = date
    },

    query(resource, params) {
        return Vue.axios.get(resource, { params }).catch(error => {
            throw new Error(`ApiService ${error}`)
        })
    },

    get(resource) {
        return Vue.axios.get(`${resource}`)
    },

    post(resource, params) {
        return Vue.axios.post(`${resource}`, params)
    },

    update(resource, params) {
        return Vue.axios.put(`${resource}`, params)
    },

    put(resource, params) {
        return Vue.axios.put(`${resource}`, params)
    },

    delete(resource) {
        return Vue.axios.delete(resource).catch(error => {
            throw new Error(`ApiService ${error}`)
        })
    }
}

export default ApiService
